import { ErrorOutline, OilBarrel, PropaneTank } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { DeviceFuelType, DeviceOrientationType } from 'types';

type DeviceFuelTypeIconProps = {
    fuelType: DeviceFuelType;
    orientation: DeviceOrientationType;
};

export const DeviceFuelTypeIcon = ({
    fuelType,
    orientation,
}: DeviceFuelTypeIconProps) => {
    if (fuelType === 'propane') {
        return (
            <Tooltip title={`Propane / ${orientation}`}>
                <PropaneTank />
            </Tooltip>
        );
    }

    if (fuelType === 'oil') {
        return (
            <Tooltip title={`Oil / ${orientation}`}>
                <OilBarrel />
            </Tooltip>
        );
    }

    return (
        <Tooltip title="Fuel Type Unknown">
            <ErrorOutline />
        </Tooltip>
    );
};
